var _path, _path2, _path3, _path4, _path5, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.2222 12.9442C64.2221 3.38872 25.3332 1.61091 12.6665 12.2775L10.6665 16.9442L23.5554 35.6109L61.7777 34.0553L68.2222 12.9442Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6665 22.4185C37.2983 19.9711 43.2464 19.8979 53.7777 22.4185",
    stroke: "#999999",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8891 40.2779C42.5565 42.5457 37.8886 42.1887 29.5558 40.2779L29.1113 31.389L38.0002 26.9446C39.679 27.4616 40.6113 27.5916 42.2225 27.1668L52.2225 28.9446L50.8891 40.2779Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2223 26.9445L20 54.9446C9.95451 48.1844 6.23243 43.3421 4 32.2779C6.9993 24.1116 8.78793 19.6325 12.6667 12.2778C18.3474 18.8009 24.5306 21.9031 38.2223 26.9445Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4444 54.9446L42.4443 27.1668C57.9703 20.0363 64.5069 16.6971 68.2222 13.1667C72.0469 21.2753 73.7779 26.1206 75.9999 35.389C72.435 45.1266 68.161 48.6816 60.4444 54.9446Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.667,
    cy: 35.389,
    r: 1.5,
    fill: "#999999",
    stroke: "#999999",
    strokeWidth: 1.44445
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKent);
export default __webpack_public_path__ + "static/media/kent.cd8e15804902a6664afce8e344c105fd.svg";
export { ForwardRef as ReactComponent };